import { render, staticRenderFns } from "./fileToObject.vue?vue&type=template&id=96fda48e&"
import script from "./fileToObject.vue?vue&type=script&lang=js&"
export * from "./fileToObject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports